<div class="nav-item">
  <button class="tabBtn text-uppercase" [matMenuTriggerFor]="menu">
    <img src="{{ picturesServer }}img/home/icono-lang.svg" alt="icono-lang" loading="lazy" />
    {{ currentLanguage.lang }}
    <i class="fa-solid fa-chevron-down"></i>
  </button>
  <mat-menu #menu="matMenu">
    <button
      mat-menu-item
      class="text-uppercase language"
      *ngFor="let language of languages"
      (click)="setLanguage(language)"
    >
      {{ language.lang }}
    </button>
  </mat-menu>
</div>
